import React from 'react';
import PropTypes from "prop-types";
import NewsletterForm from "./NewsletterForm";
import SuccessIcon from "./SuccessIcon";

const NewsletterBody = ({success, emailValue, handleEmailChange, onSubmit, errors}) => {
    if (success) {
        return (
            <div className="newsletter__body">
                <h1>All done!</h1>
                <p>You have successfully signed up for the newsletter</p>
                <SuccessIcon />
            </div>
        );
    }
    return (
        <div className="newsletter__body">
            <h1>Sign up for our newsletter</h1>
            <p>
                Ready to start shopping at Novastar?<br />
                Sign up for our newsletter to get notified when we launch.
            </p>
            <NewsletterForm
                emailValue={emailValue}
                errors={errors}
                handleEmailChange={handleEmailChange}
                onSubmit={onSubmit}
            />
        </div>
    );
};

NewsletterBody.propTypes = {
    ...NewsletterForm.propTypes,
    success: PropTypes.bool.isRequired,
};

export default NewsletterBody;



// WEBPACK FOOTER //
// ./src/components/NewsletterBody.js